import React from "react";
import { Account, Terminal, TransactionFormData, TransactionDisplayValues } from "../../types";

interface TransactionPreviewProps {
  formData: TransactionFormData;
  displayValues: TransactionDisplayValues;
  accounts: Account[];
  availableTerminals: Terminal[];
  error?: string;
  onBack: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const TransactionPreview: React.FC<TransactionPreviewProps> = ({
  formData,
  displayValues,
  accounts,
  availableTerminals,
  error,
  onBack,
  onConfirm,
  loading = false,
}) => {
  const selectedAccount = accounts.find(acc => acc.id === formData.accountId);
  const selectedTerminal = availableTerminals.find(term => term.id === formData.terminalId);

  return (
    <div className="transaction-preview">
      <div className="preview-header">
        <h3>📋 Transaction Preview</h3>
        <p>Please review the transaction details below before confirming.</p>
      </div>
      
      <div className="preview-details">
        <div className="preview-section">
          <h4>Account & Terminal</h4>
          <div className="preview-item">
            <span className="preview-label">Account:</span>
            <span className="preview-value">
              {selectedAccount?.identifier || "Unknown"} - 
              {selectedAccount?.paymentGateway || "Unknown"}
            </span>
          </div>
          <div className="preview-item">
            <span className="preview-label">Terminal:</span>
            <span className="preview-value">
              {selectedTerminal?.identifier || "Unknown"} - 
              {selectedTerminal?.tid || "Unknown"}
            </span>
          </div>
        </div>

        <div className="preview-section">
          <h4>Transaction Details</h4>
          <div className="preview-item">
            <span className="preview-label">Invoice:</span>
            <span className="preview-value">{formData.orderId}</span>
          </div>
          <div className="preview-item">
            <span className="preview-label">Amount:</span>
            <span className="preview-value highlight">{displayValues.amount}</span>
          </div>
          <div className="preview-item">
            <span className="preview-label">Tip Amount:</span>
            <span className="preview-value">{displayValues.tipAmount}</span>
          </div>
          <div className="preview-item total">
            <span className="preview-label">Total:</span>
            <span className="preview-value highlight">
              ${(formData.amount + formData.tipAmount).toFixed(2)}
            </span>
          </div>
        </div>
      </div>

      {error && (
        <div className="user-list-error" style={{ margin: "1rem 0" }}>
          {error}
        </div>
      )}

      <div className="preview-actions">
        <button
          type="button"
          className="btn secondary"
          onClick={onBack}
          disabled={loading}
        >
          ← Back to Form
        </button>
        <button
          type="button"
          className="btn primary"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Processing..." : "✅ Confirm Transaction"}
        </button>
      </div>
    </div>
  );
};

export default TransactionPreview; 